import React from 'react';
import { Card } from './ui/card';

const DomainExpertise = () => {
  const domains = [
    {
      title: 'Brand Building & Narrative Design',
      description: 'Positioning, messaging, and storytelling that creates differentiation and trust—not just awareness.',
    },
    {
      title: 'Performance & Growth Marketing',
      description: 'Acquisition engines built for efficiency, not vanity metrics. CAC, LTV, and payback periods are the language.',
    },
    {
      title: 'Product Marketing & GTM',
      description: 'Launching products that people actually want, with messaging that makes the value obvious from day one.',
    },
    {
      title: 'Content Systems & Distribution',
      description: 'Scalable content engines—SEO, social, email—designed for reach and leverage, not just volume.',
    },
    {
      title: 'Marketing Operations & Analytics',
      description: 'The plumbing that makes everything else work—dashboards, attribution, and decision-making infrastructure.',
    },
    {
      title: 'AI-Augmented Marketing Systems',
      description: 'Using AI to automate workflows, personalize at scale, and operate lean teams with high output.',
    },
  ];

  return (
    <section id="expertise" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-900 mb-4">Domain Expertise</h2>
        <p className="text-slate-600 mb-12 max-w-3xl">
          Core marketing domains I've led and built across—explained in outcomes, not tools.
        </p>

        <div className="grid md:grid-cols-2 gap-6">
          {domains.map((domain, index) => (
            <Card key={index} className="p-6 border-slate-200 hover:border-slate-300 transition-colors">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">{domain.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{domain.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DomainExpertise;